module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "backtop",
    attrs: {
      "top": _vm.top
    },
    on: {
      "click": _vm.backTop
    }
  }, [_vm._t("default", [_c('i', {
    staticClass: "iconfont icon-jiantoushang"
  })])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58709f3c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backtop/backtop.vue
// module id = 239
// module chunks = 28